"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicFormBlockModule = /** @class */ (function () {
    function DynamicFormBlockModule() {
    }
    return DynamicFormBlockModule;
}());
exports.DynamicFormBlockModule = DynamicFormBlockModule;
